"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDashboardIdIfExists = void 0;
exports.getPortalIdOfHostingFrame = getPortalIdOfHostingFrame;
exports.isPathAvailableInGivenPortal = void 0;
exports.isRenderedInPortalFrame = isRenderedInPortalFrame;
exports.notifyPlatformIfSideNavVisible = notifyPlatformIfSideNavVisible;
/* eslint-disable camelcase */

function isRenderedInPortalFrame() {
  try {
    return window.parent !== window.self && window.parent.Q_PortalsContext !== undefined;
  } catch (_unused) {
    // in case we're inside an iframe with cross-origin blocked and we cannot access parent
    return false;
  }
}
function getPortalIdOfHostingFrame() {
  if (isRenderedInPortalFrame()) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return window.parent.Q_PortalsContext.portalId;
  }
  return undefined;
}
var isPathPassingValidationLists = function isPathPassingValidationLists(validationURLLists, path) {
  if (!path) return true;
  if (validationURLLists.URLBlockList) {
    var _validationURLLists$U;
    var isPathBlocked = (_validationURLLists$U = validationURLLists.URLBlockList) === null || _validationURLLists$U === void 0 ? void 0 : _validationURLLists$U.some(function (url) {
      var regex = new RegExp(url);
      return regex.test(path);
    });
    if (isPathBlocked) {
      return false;
    }
  }
  if (!validationURLLists.URLAllowList || validationURLLists.URLAllowList.length === 0) {
    return true;
  }
  return validationURLLists.URLAllowList.some(function (url) {
    var regex = new RegExp(url);
    return regex.test(path);
  });
};
var getDashboardIdIfExists = function getDashboardIdIfExists(path) {
  if (path) {
    var splitPath = path.replace('/#', '').replace('#', '').split('/');
    if (splitPath.length > 3) {
      var isDashboard = splitPath[1] === 'reporting-dashboard';
      var _dashboardId = splitPath[3];
      if (isDashboard && _dashboardId !== '') return _dashboardId;
    }
  }
  return undefined;
};
exports.getDashboardIdIfExists = getDashboardIdIfExists;
var isDashboardPassingTypeValidation = function isDashboardPassingTypeValidation(dashboardId, allowedDashboardTypes, getDashboardType) {
  return getDashboardType(dashboardId).then(function (dashboardType) {
    if (dashboardType) {
      return allowedDashboardTypes.includes(dashboardType);
    }
    return true;
  });
};
var isPathAvailableInGivenPortal = function isPathAvailableInGivenPortal(portalData, path, getDashboardType) {
  var validationListResult = isPathPassingValidationLists(portalData, path);
  if (validationListResult && path && portalData.allowedDashboardTypes && getDashboardType) {
    var _dashboardId2 = getDashboardIdIfExists(path);
    if (_dashboardId2) {
      return isDashboardPassingTypeValidation(_dashboardId2, portalData.allowedDashboardTypes, getDashboardType);
    }
  }
  return Promise.resolve(validationListResult);
};
exports.isPathAvailableInGivenPortal = isPathAvailableInGivenPortal;
function notifyPlatformIfSideNavVisible(isSideNavVisible) {
  var _windowData$Q_Portals;
  var windowData = window.parent;
  (_windowData$Q_Portals = windowData.Q_PortalsContext) === null || _windowData$Q_Portals === void 0 ? void 0 : _windowData$Q_Portals.setIfShowSideNav(isSideNavVisible);
}
//# sourceMappingURL=index.js.map